import { Outlet } from "react-router";
import { LiffProvider, AuthProvider } from "@/auth";

/**
 * Auth Layout
 * Wraps authenticated routes with LIFF and Authentication Providers
 *
 * This layout wraps all routes that require LINE LIFF authentication and server auth:
 * - LIFF SDK initialization happens here (outer provider)
 * - Server authentication setup happens here (inner provider)
 * - LIFF context is available to all child routes
 * - Auth context is available to all child routes
 * - Handles LIFF login flow and automatic server token exchange
 *
 * Provider hierarchy:
 * LiffProvider (LINE authentication)
 *   └── AuthProvider (Server authentication - depends on LIFF)
 *       └── Routes
 *
 * Routes wrapped by this layout:
 * - / (home/auto-login)
 * - /signup
 * - /reload/qrcode
 */
export default function AuthLayout() {
  return (
    <LiffProvider>
      <AuthProvider>
        <Outlet />
      </AuthProvider>
    </LiffProvider>
  );
}
